import cn from 'classnames';
import React, { CSSProperties } from 'react';

import s from './styles.module.css';

interface IProps {
  outerClassName?: string;
  innerClassName?: string;
  outerRef?: React.Ref<HTMLDivElement>;
  innerRef?: React.Ref<HTMLDivElement>;
  children: React.ReactNode;
  style?: CSSProperties;
  dataTestId?: string;
}

const CenteringContainer: React.FC<IProps> = ({
  outerRef,
  innerRef,
  outerClassName,
  innerClassName,
  children,
  style,
  dataTestId,
}) => (
  <div
    className={cn(s.outer, outerClassName)}
    style={style}
    ref={outerRef}
    data-test-id={dataTestId}
  >
    <div className={cn(s.inner, innerClassName)} ref={innerRef}>
      {children}
    </div>
  </div>
);

export { CenteringContainer };
